export const STEPS = [
  {
    name: "รายละเอียด",
    value: 1
  },
  {
    name: "เลือกเเผน",
    value: 2
  },
  {
    name: "กรอกข้อมูล",
    value: 3
  },
  {
    name: "ชำระเงิน",
    value: 4
  }
];

export const DELIVERY_BY = [
  { value: "รถยนตร์ส่วนบุคคล", label: "รถยนตร์ส่วนบุคคล" },
  { value: "รถโดยสารประจำทาง", label: "รถโดยสารประจำทาง" },
  { value: "เครื่องบินโดยสาร", label: "เครื่องบินโดยสาร" },
  { value: "รถไฟ", label: "รถไฟ" },
  { value: "เรือโดยสาร", label: "เรือโดยสาร" },
  { value: "อื่นๆ", label: "อื่นๆ" }
];

export const PURPOSE_OF_TOURISM = [
  {
    value: "รถยนตร์ส่วนบุคคลท่องเที่ยว (ไม่มีกิจกรรมผาดโผน)",
    label: "ท่องเที่ยว (ไม่มีกิจกรรมผาดโผน)",
    isRisk: 0
  },
  {
    value: "ท่องเที่ยว (มีกิจกรรมดำน้ำตื้น/ล่องแก่ง/ล่องแพ)",
    label: "ท่องเที่ยว (มีกิจกรรมดำน้ำตื้น/ล่องแก่ง/ล่องแพ)",
    isRisk: 1
  },
  {
    value: "ท่องเที่ยว (Extreme activity)",
    label: "ท่องเที่ยว (Extreme activity)",
    isRisk: 1
  },
  {
    value: "สัมมนา/อบรม/ประชุม/ดูงาน/ศึกษา",
    label: "สัมมนา/อบรม/ประชุม/ดูงาน/ศึกษา",
    isRisk: 0
  },
  {
    value: "ทำงาน/ฝึกงานประจำสักงาน",
    label: "ทำงาน/ฝึกงานประจำสักงาน",
    isRisk: 0
  },
  {
    value: "จัดการแสดง/นิทรรศการ/ออกบูธ/โปรโมทสินค้า",
    label: "จัดการแสดง/นิทรรศการ/ออกบูธ/โปรโมทสินค้า",
    isRisk: 0
  }
];
